import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Figured Case Study | Canny';
const Description =
  'Read about how Figured uses Canny to strengthen team collaboration and build community.';
const Image = 'https://canny.io/images/helmet-figured-case-study.jpg';
const FiguredUrl = 'https://canny.io/case-studies/figured';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${FiguredUrl}#webpage`,
    url: FiguredUrl,
    name: 'Case Study: Figured × Canny',
    description: 'How Figured uses Canny to strengthen team collaboration and build community.',
    inLanguage: 'en',
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createArticle('Article', {
    '@id': `${FiguredUrl}#article`,
    genre: 'Case Study',
    headline: 'How Figured uses Canny to strengthen team collaboration and build community',
    description:
      "Feedback was scattered and underserved using their previous tool, leading to low engagement. Figured adopted Canny's intuitive interface and integrations across Intercom and Slack—making feedback easy to capture and visible to everyone in the company from CS to the CEO. This created spontaneous collaboration, improved internal alignment, and transformed feedback into a vibrant mini community.",
    inLanguage: 'en',
    url: FiguredUrl,
    mainEntityOfPage: { '@id': `${FiguredUrl}#webpage` },
    author: {
      '@type': 'Organization',
      '@id': 'https://canny.io/#organization',
      name: 'Canny',
      url: 'https://canny.io',
    },
    publisher: { '@type': 'Organization', '@id': 'https://canny.io/#organization' },
    about: { '@type': 'Organization', name: 'Figured', url: 'https://figured.com' },
  }),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Case Studies', item: 'https://canny.io/case-studies' },
    { name: 'Figured', item: FiguredUrl },
  ]),
]);

export default class FiguredLandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: FiguredUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
